export default __webpack_public_path__ + "static/media/map.c1809b57.png";